<template>
  <a-divider orientation="left">车位识别结果</a-divider>
  <a-card>
    <a-table :pagination="false" :columns="identifyColumns" :data-source="identifySource" bordered>
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'color'">
          {{carColor[record.color]}}
        </template>
      </template>
    </a-table>
  </a-card>
</template>
<script setup>
// 车位识别结果
import {ref} from "vue";
import {axiosGet} from "@/layouts/admin-sidebar/requstDev";
import api from "@/service/api";
import singleDev from "@/stores/singleDev";
import load from "@/common/load";

let single = singleDev();
let carColor = ["未知", "蓝色", "黄色", "白色", "褐色", "绿色"];
let identifyColumns = [
  {
    title: '车位号',
    dataIndex: 'park_no',
    key: 'park_no'
  },
  {
    title: '识别时间',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '识别车牌',
    dataIndex: 'license',
    key: 'license'
  },
  {
    title: '空满',
    dataIndex: 'nType',
    key: 'nType'
  },
  {
    title: '车位颜色',
    dataIndex: 'color',
    key: 'color'
  },
  {
    title: '置信度',
    dataIndex: 'car_type',
    key: 'car_type'
  },
];
single.$subscribe((mutation, state)=>{
  console.log(mutation)
  console.log(state)
  if(mutation.events.key === 'identityPark'){
    identifyInit();
  }
})
// 表格数据
let identifySource = ref([]);
let failureCount = 0; // 初始化失败计数器

let getParkNumber = async (i) => {
  try {
    let result = await axiosGet(api.getParkIdentify.replace(/-/g, single.currentCode.qrCode).replace(/#/g, i) + '?' + new Date().getTime());
    if (Object.keys(result).length === 5) {
      identifySource.value.push(Object.assign({ park_no: i + 1 }, result));
      identifySource.value.sort((a, b) => {
        return a.park_no - b.park_no;
      });
      failureCount = 0; // 重置失败计数器
    } else {
      failureCount++;
      if (failureCount >= 2) {
        return '请求失败两次以上'; // 或者其他处理方式
      }
      load.error('获取车位识别结果失败...');
    }
  } catch (e) {
    failureCount++;
    if (failureCount >= 2) {
      return '请求失败两次以上'; // 或者其他处理方式
    }
    load.error('获取车位识别结果失败...');
  }
}
let identifyInit = () => {
  identifySource.value = [];
  if(Object.keys(single.identityPark).length){
    for (let i = 0; i < single.identityPark.park_control.length; i++) {
      getParkNumber(i)
    }
  }
}
identifyInit()


</script>

<style scoped lang="scss">

</style>
